const styles = (theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.backgroundColor
    }
  }
})

export {
  styles
}